import gql from 'graphql-tag';

const MODIFY_SERVICE_RUN = gql`
	mutation modifyServiceRunMutation($input: ModifyServiceRunInput!) {
		modifyServiceRun(input: $input) {
			servicerun {
				id
				planned
				restockType
				driver {
					id
					username
					firstname
					lastname
				}

				startLocation {
					id
					name
					coordinates
					destroyed
				}
				machineOrder

				vehicle {
					id
					name
					registration
				}
				vehicleConfirmed

				serviceDockets {
					id
					order
				}

				warehouse {
					id
					name
				}

				returnWarehouse {
					id
					name
				}
		
				endLocation {
					id
					name
					coordinates
					destroyed
				}
				brief
				debriefComment
			}
		}
	}
`;

export default MODIFY_SERVICE_RUN;
